export default class MobileNavigation {
	constructor() {
		this.hamburger = document.getElementById("hamburger");
		this.mobileNavigation = document.getElementById("mobile-navigation");

		this.toggleNavigation();
	}

	toggleNavigation() {
		if (this.hamburger) {
			this.hamburger.addEventListener(
				"touchstart",
				(e) => {
					if (this.mobileNavigation.classList.contains("-translate-y-full")) {
						this.hamburger.classList.add("active");
						this.mobileNavigation.classList.remove("opacity-0");
						this.mobileNavigation.classList.remove("-translate-y-full");
						this.mobileNavigation.classList.add("opacity-100");
						this.mobileNavigation.classList.add("translate-y-0");
					} else {
						this.hamburger.classList.remove("active");
						this.mobileNavigation.classList.add("opacity-0");
						this.mobileNavigation.classList.add("-translate-y-full");
						this.mobileNavigation.classList.remove("opacity-100");
						this.mobileNavigation.classList.remove("translate-y-0");
					}
				},
				{
					passive: true,
				}
			);
		}
	}
}
